<template>
  <div class="course-detail-wrapper">
    <!-- 初始化显示Loading -->
    <template v-if="isInitLoading || queryDetailStatus == 0">
      <DetailSkeleton />
    </template>
    <!-- 页面异常状态 -->
    <template v-else-if="queryDetailStatus == 2">
      <Exception placeholder-class-name="no-avalible-data-img"
                 :show-retry-btn="true" class="error-container"
                 :retry-btn-text="$t('coursesDetail.retryBtnText')"
                 :tip-text="$t('coursesDetail.exceptiontip')"
                 @retry="exceptionRetryHandler"
      />
    </template>
    <template v-else-if="queryDetailStatus == 1">
      <div class="course-detail">
        <div id="classDetailBreadcrumb" class="wrapper course-detail-crumb">
          <NewDetailBreadcrumb
            v-if="detailData.spec"
            :category-name="$t('coursesDetail.categoryName')"
            category-path="/courses/list"
            :second-category-name="getCoursesTypeName(detailData.spec.courseType)"
            :title="detailData.title"
          />
        </div>
        <div class="wrapper outline-introduce">
          <div ref="classInfo" class="class-info">
            <!-- 班级信息卡片 -->
            <ClassCard class="class-main-info-card"
                       card-class="long-card" :card-data="detailData" :show-teacher-info="false" :show-card-bottom="false" :card-clickable="false"
                       :total-lessons="detailData.spec.lessonCount" :left-lessons="detailData.spec.eduLeftLesson"
                       :show-right-top-tag="!detailData.spec.courseClosed"
                       :tag-type="getClassHotTagType(detailData.store, detailData.sellStore, detailData.remainSellTime)"
                       :show-back-stamp="true"
                       :sub-platform-type="detailData.spec.subPlatformType"
                       :platform-type="detailData.spec.platformType"
                       :show-first-lesson-time="false"
                       show-venue-phone
                       show-address-detail
            />
            <!-- 拼团活动 -->
            <ActivityGroup v-if="activityInfo.activityType == 6" :id="activityGroupEleId"
                           from-type="courses-detail"
                           :activity-info="activityInfo"
                           :class-id="detailData.spec.clazzId"
                           :show-group-list="signUpRemainTime < 1000" @join-in-group="joinInGroupHandler" @refresh="updateGroupData(skuId)"
            >
              <template v-slot:activity-price>
                {{ currency }}{{ (activityInfo.perShowPrice !== undefined? activityInfo.perShowPrice:activityInfo.showPrice) | priceUnitConvert(minorUnit) }}
              </template>
              <template v-slot:org-price>
                {{ currency }}{{ (detailData.perShowPrice !== undefined? detailData.perShowPrice:detailData.showPrice) | priceUnitConvert(minorUnit) }}
              </template>
            </ActivityGroup>
            <!-- 服务信息-后台配置 -->
            <ServiceHighlights v-if="Array.isArray(highlights) && highlights.length > 0"
                               :show-decoration="activityInfo.activityType == 6"
                               :highlights="highlights"
            />
            <!-- 教材费零期-费用说明-后台配置 -->
            <template v-if="detailData.spec && detailData.spec.feeDescClazz">
              <div class="fee-description font-medium">
                {{ detailData.spec.feeDescClazz }}
              </div>
            </template>
            <!-- 诊断入口 -->
            <template v-if="evaluation.entranceStatus > 0">
              <div class="evaluation-entrance-wrapper"
                   :class="{'clickable': evaluation.entranceStatus == 1 || evaluation.entranceStatus == 2}"
                   @click="handleEvaluationEntranceClick"
              >
                <div class="evaluation-entrance-container">
                  <div class="evaluation-logo-img" :class="evaluation.entranceStatus == 3 ? 'success': 'common'" />
                  <div class="evaluation-detail-info font-medium">
                    <p class="evaluation-name">
                      {{ evaluationName }}
                    </p>
                    <p class="evaluation-desc">
                      {{ evaluationStatusTxt }}
                    </p>
                  </div>
                </div>
              </div>
            </template>
            <!-- 教师信息模块 -->
            <Teachers id="courseTeachers" :detail-data="detailData" />
            <!-- 使用学员描述-后台配置 -->
            <Suitable :detail-data="detailData" />
            <!-- 讲次列表 -->
            <ClassOutline id="courseSyllabus" class="class-outline" :detail-data="detailData" :course-schedule="courseSchedule" />
            <CourseDetails :detail-data="detailData" />
            <!-- 3步上课指引 -->
            <ProcedureIntroduction v-if="isBetterMe !== 'bettermeedu'" class="procedure-introduction" :course-detail="detailData" />
          </div>
          <!-- 右侧悬浮班级卡片 -->
          <div class="course-information" :style="{ 'top': courseInformationTop + 'px' }">
            <div class="top-courses-info">
              <Audition :detail-data="detailData" />
              <ClassCard :card-data="detailData" :show-teacher-info="false" :show-card-bottom="false" :card-clickable="false"
                         :show-tag-info="false"
                         :show-level-degree="false"
                         :show-lesson-num="false"
                         :sub-platform-type="detailData.spec.subPlatformType"
                         :platform-type="detailData.spec.platformType"
                         :show-first-lesson-time="false"
                         :show-class-store="false"
              />
            </div>
            <template v-if="!goodInActivity">
              <PriceStatus
                :detail-data="detailData"
                :minor-unit="minorUnit"
                :currency="currency"
                :is-wish="isWish"
                :from-page="fromPage"
                :price-model="priceModel"
                :sign-up-remain-time="signUpRemainTime"
                :discount-price="recommendDiscountPrice"
                :price-after-coupon="priceAfterCoupon"
              />
              <!-- 券后价提示气泡 -->
              <template v-if="couponsStuList.length > 0 ">
                <template v-if="locale == 'hk'">
                  <div class="coupon-tip-hk font-medium">
                    <p class="coupon-tip-title">
                      {{ $t('coursesDetail.childList') }}
                      <span v-for="item in couponsStuList" :key="item.uid">
                        {{ easternNameOrderEnabled ? `${item.lastName || ''}${item.firstName || ''}` || item.nickName
                          : (item.firstName || item.lastName) ? `${item.firstName || ''} ${item.lastName || ''}` : item.nickName }}{{ ',' }}
                      </span>
                      {{ $t('coursesDetail.childList2') }}
                    </p>
                    <!-- <p class="coupon-tip-title">
                      {{ $t('coursesDetail.couponTipTitle') }}
                    </p> -->
                    <p class="coupon-tip-des">
                      {{ $t('coursesDetail.couponTipDes') }}
                    </p>
                  </div>
                </template>
                <template v-else>
                  <div class="coupon-tip-bubble font-medium" :class="{show: showCouponBubble}">
                    <p>
                      {{ $t('coursesDetail.childList') }}
                      <span v-for="item in couponsStuList" :key="item.uid">
                        {{ easternNameOrderEnabled ? `${item.lastName || ''}${item.firstName || ''}` || item.nickName
                          : (item.firstName || item.lastName) ? `${item.firstName || ''} ${item.lastName || ''}` : item.nickName }}{{ ',' }}
                      </span>
                      {{ $t('coursesDetail.childList2') }}
                    </p>
                    <!-- <p>
                      {{ $t('coursesDetail.couponTipTitle', {discount: discountText}) }}
                    </p> -->
                    <div class="btn-close" @click="hiddenCouponBubble">
                      <i class="iconfont icon-close-new" />
                    </div>
                  </div>
                </template>
              </template>
            </template>
            <CourseStatus
              :detail-data="detailData"
              :activity-info="activityInfo"
              :btn-status="btnStatus"
              :sign-up-remain-time="signUpRemainTime"
              :is-wish="isWish"
              :follow-sku-id="courseId"
              @signUp="registrationHandler"
            />
          </div>
        </div>
      </div>
    </template>

    <no-ssr>
      <AssessmentNotice v-if="showAssessmentNotice" :test-url="assessmentTestUrl" />
      <EvaluationDialog :evaluation-dialog-info="evaluationDialogInfo" :show.sync="showEvaluationDialog" :detail-data="detailData" />
      <ConfirmDialog :show.sync="confirmDialogConfig.show" :title="confirmDialogConfig.title" :content="confirmDialogConfig.content"
                     :sub-btn-text="confirmDialogConfig.subBtnText" :main-btn-text="confirmDialogConfig.mainBtnText"
                     @subBtnClick="confirmDialogConfig.subBtnClick" @mainBtnClick="confirmDialogConfig.mainBtnClick"
      >
        <template v-if="signUpStatus == 1 || signUpStatus == 2" v-slot:content-bottom>
          <div class="evaluation-redeem-code-entrance">
            <p class="desc-text font-medium" @click="openEvaluationRedeemDialog">
              {{ $t('coursesDetail.redeemCodeEntrance[0]') }} <span class="btn-text hover-transition">{{ $t('coursesDetail.redeemCodeEntrance[1]') }}</span>
            </p>
          </div>
        </template>
      </ConfirmDialog>
      <SuccessDialog :show.sync="isFirstWish" :title="$t('coursesDetail.successDialog.title')" :desc="$t('coursesDetail.successDialog.desc')" :btn-text="$t('coursesDetail.successDialog.btnText')" />
      <SwitchStudentDialog ref="coursesDetailSwitchStudentDialog" :switch-stu-tip-text="switchStuTipText" :is-add-cart="isAddCart" @switch-success="switchSuccessHandler" />
      <VideoPopup ref="videoPopup" />

      <RedeemDialog ref="evaluationRedeemDialog" origin="registration" :course-detail="detailData" @main-click="redeemMainClickHandler" />
    </no-ssr>
  </div>
</template>
<script>
import bus from 'common/bus'
import { oneApi } from 'config/api'
import evaluation from 'common/evaluation.js'
import ClassCard from 'components/courses/ClassCard'
import ServiceHighlights from 'components/coursesDetail/ServiceHighlights'
import ActivityGroup from 'components/coursesDetail/ActivityGroup';
import ClassOutline from 'components/courses/CourseOutline'
import CourseDetails from 'components/courses/CourseDetails'
import Audition from 'components/courses/CourseInformation/Audition'
import CourseStatus from 'components/courses/CourseInformation/CourseStatus'
import PriceStatus from 'components/courses/CourseInformation/PriceStatus'
import ProcedureIntroduction from 'components/courses/ProcedureIntroduction'
import AssessmentNotice from 'components/courses/AssessmentNotice'
import NewDetailBreadcrumb from 'components/common/NewDetailBreadcrumb'
import EvaluationDialog from 'components/courses/EvaluationDialog'
import RedeemDialog from 'components/test/RedeemDialog';
import Exception from 'components/common/Exception/index.vue'
import SuccessDialog from 'components/common/SuccessDialog'
import Teachers from 'components/courses/Teachers'
import Suitable from 'components/courses/Suitable'
import DetailSkeleton from 'components/courses/DetailSkeleton/index.vue'
import SwitchStudentDialog from 'components/courses/SwitchStudentDialog'
import VideoPopup from 'components/common/VideoPopup/index';
import ConfirmDialog from 'components/common/ConfirmDialog/index.vue';

// mixins
import coursesSa from 'mixins/courses/sa.js';
import coursesCommon from 'mixins/courses/common.js'
import couponMixins from 'mixins/coupon/index.js'
import activity from 'mixins/courses/detail/activity.js';
import recordMixins from 'mixins/courses/detail/record.js';

import filters from 'common/filters.js';

// 节流函数
const throttle = require('lodash/throttle')

export default {
  components: {
    DetailSkeleton,
    NewDetailBreadcrumb,
    ClassCard,
    ServiceHighlights,
    ActivityGroup,
    ClassOutline,
    CourseDetails,
    ProcedureIntroduction,
    AssessmentNotice,
    EvaluationDialog,
    Exception,
    SuccessDialog,
    Audition,
    CourseStatus,
    PriceStatus,
    SwitchStudentDialog,
    Teachers,
    Suitable,
    VideoPopup,
    ConfirmDialog,
    RedeemDialog,
  },
  mixins: [recordMixins, coursesCommon, couponMixins, activity, coursesSa],
  async asyncData({ $axios, store }) {
    // 刷新页面进行数据异步请求
    const promiseList = [
      // 请求学科类型列表
      store.dispatch('courses/queryCourseTypes', { $axios }),
    ]
    await Promise.all(promiseList)
      .then(() => {
        console.log('请求成功');
      }).catch(() => {
        console.log('请求失败')
      });
  },
  data() {
    const courseId = this.$route.params.coursesId;
    const { fromPage, studentId, firstLessonNum } = this.$route.query;
    return {
      isAddCart: false,
      studentsList: [],
      studentInfo: null,
      studentId,
      firstLessonNum,
      fromSource: '',
      isOnSale: true,
      // 是否正在初始化
      isInitLoading: false,
      // 购买流程中
      isBuying: false,
      // 班级详情数据请求状态
      // 0: 请求中
      // 1: 请求成功
      // 2: 请求失败
      queryDetailStatus: 0,
      // 切换学员后是否需要刷新数据
      isNeedRefresh: false,
      courseId,
      skuId: courseId,
      // 详情页数据
      detailData: {},
      // 课程大纲数据
      courseSchedule: [],
      // 下载工具
      tool: '',
      // 年级
      grade: '',
      // 初始化loading的高度
      marginTop: 300,
      // 诊断弹窗信息
      evaluationDialogInfo: {
        title: '',
        message: '',
        confirmButtonText: '',
        showCancel: true,
        res: {},
      },
      // 诊断入口
      evaluationName: this.$t('evaluation.name'),
      evaluation: {
        entranceStatus: 0,
        examId: '',
      },
      // 报班资格校验结果
      signUpStatus: 0,
      showEvaluationDialog: false,
      // 售卖倒计时
      signUpRemainTime: 0,
      headerRef: null,
      isWish: false,
      isFirstWish: false,
      isWishEnd: true,
      isError: false,
      activeIndex: 0,
      fromPage,
      addWishRes: null,
      res: null,
      confirmDialogConfig: {
        show: false,
        title: '',
        content: '',
        mainBtnText: '',
        mainBtnClick: () => {},
        subBtnText: '',
        subBtnClick: () => {},
      },
      // 价格状态相关参数
      showCouponBubble: true,
      courseInformationTop: 0,
      // 1 长期班，其余 非长期班
      courseType: 1,
    }
  },
  computed: {
    locale() {
      return this.$store.state.locale
    },
    isBetterMe() {
      return this.$store.state.betterme
    },
    easternNameOrderEnabled() {
      const { easternNameOrderEnabled } = JSON.parse(window.localStorage.getItem('clientOptions')) || {}
      return easternNameOrderEnabled || false
    },
    // 获取课程类型列表
    coursesTypeList() {
      return this.$store.state.courses.coursesTypeList
    },
    // 是否显示诊断提示
    showAssessmentNotice() {
      // 新加坡 并且 年级为: 1、2、3、4、5时显示
      return this.$store.state.locale === 'sg' && this.grade !== '' && (this.grade >= 0 && this.grade <= 4);
    },
    // 诊断测试地址
    assessmentTestUrl() {
      const gradeAssessmentMap = this.$t('courses.gradeAssessmentMap');
      const url = gradeAssessmentMap[this.grade];
      return url;
    },
    // 是否满班状态
    btnStatus() {
      const {
        signUpRemainTime, detailData,
      } = this
      const {
        spec: { courseClosed }, sellStore, store, subscriptionsStatus,
      } = detailData
      if (courseClosed) {
        return this.fromPage === 'unpaid-courses-list' ? 'unavailable' : 'courseEnded'
      }
      if (signUpRemainTime > 1000) {
        return 'forSale'
      }
      // 自动扣款中
      if (subscriptionsStatus === 1) {
        return 'enrolNow' // autoPayInProcess
      }
      // 待缴费清单不存在报满状态
      if (store - sellStore <= 0 && this.fromPage !== 'unpaid-courses-list') {
        return 'full'
      }
      if (this.fromPage === 'unpaid-courses-list') {
        return 'enrolNow'
      }
      return 'enrol'
    },
    allTeacherList() {
      const allList = this.detailData.spec.teacherList.concat(this.detailData.spec.tutorList)
      return allList
    },

    priceModel() {
      if (Number(this.detailData.showOrgPrice) === 0 && Number(this.detailData.showPrice) === 0) {
        return 'free'
      }
      if (Number(this.detailData.showOrgPrice) <= Number(this.detailData.showPrice)) {
        return 'noDiscount'
      }
      return 'discount'
    },
    currency() {
      return this.$store.state.currency.symbol
    },
    minorUnit() {
      return this.$store.state.currency.minorUnit;
    },
    operation() {
      return JSON.parse(this.detailData.operation || '{}')
    },
    highlights() {
      return this.operation.dynamic && this.operation.dynamic.highlight
    },
    // 切换学员弹窗提示文案
    switchStuTipText() {
      if (this.recommendDiscountPrice > 0) {
        return ''
      }
      if (this.activityInfo.activityType === 6) {
        if (!this.groupData || !this.groupData.groupParam) return ''
        const groupParam = this.groupData.groupParam || {}
        if ((Array.isArray(groupParam.creatorTags) && groupParam.creatorTags.length > 0)
            || (Array.isArray(groupParam.memberTags) && groupParam.memberTags.length > 0)) {
          return this.$t('order.shoppingCart.promoNotice')
        }
        return ''
      }
      return ''
    },
    // (新)诊断入口文案
    evaluationStatusTxt() {
      let result = ''
      switch (this.evaluation.entranceStatus) {
        case 0:
          break;
        case 1:
          result = this.$t('coursesDetail.evaluationStatusTxt.case1');
          break;
        case 2:
          result = this.$t('coursesDetail.evaluationStatusTxt.case2');
          break;
        case 3:
          result = this.$t('coursesDetail.evaluationStatusTxt.case3');
          break;
        case 4:
          result = this.$t('coursesDetail.evaluationStatusTxt.case4');
          break;
        default:
          break;
      }
      return result;
    },
    discountText() {
      return `${this.currency}${filters.priceUnitConvert(this.recommendDiscountPrice, this.minorUnit, this.$t('common.isKeepTwoDecimal'))}`
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // eslint-disable-next-line no-param-reassign
      vm.fromSource = from.name
    })
  },
  mounted() {
    this.setCourseInformationTop()
    this.$nextTick(() => {
      this.init()
    })
    bus.$on('courses.detail.registrationCourses', (isNeesSwitchStudent = false) => {
      if (isNeesSwitchStudent) this.registrationCheckUser()
      else this.registrationCourse();
    });
    bus.$on('operateWish', () => {
      this.operateWish()
    })
    bus.$on('openVideo', (trialLessonsUrl) => {
      this.openVideo(trialLessonsUrl)
    })
    bus.$on('courses.detail.refresh', () => {
      this.queryCourseDetail();
    });
  },
  beforeDestroy() {
    bus.$off('courses.detail.registrationCourses')
    bus.$off('operateWish')
    bus.$off('openVideo')
    bus.$off('courses.detail.refresh')
  },
  methods: {
    async init() {
      this.isInitLoading = true
      await this.queryCourseDetail()
      this.isInitLoading = false
    },
    openVideo(trialLessonsUrl) {
      setTimeout(() => {
        this.$refs.videoPopup.handleOpen(trialLessonsUrl)
      }, 100)
    },
    async operateWish() {
      if (!this.isWishEnd) {
        return
      }
      this.isWishEnd = false
      const data = {
        skuList: [this.$route.params.coursesId],
        studentId: this.$route.query.studentId || '',
      };
      if (this.isWish) {
        await this.cancelCollect(data)
        this.collectClickHandler('取消')
      } else {
        await this.addCollect(data)
        this.collectClickHandler('收藏')
        this.isFirstWish = this.addWishRes.data.firstWish
        if (!this.isFirstWish) { this.wishToast(this.$t('coursesDetail.successDialog.title')) }
      }
      this.isWish = !this.isWish;
    },
    wishToast(msg) {
      this.$ElMessage({
        type: 'success',
        iconClass: '',
        message: msg,
        center: true,
        offset: 100,
        customClass: 'el-message-toast',
      })
    },
    async addCollect(data) {
      const res = await this.$axios.post(oneApi.queryAddWish, data, { rewritePostBody: true, uid: data.studentId });
      this.isWishEnd = true
      if (Number(res.code) !== 0) {
        this.wishToast('Failed to add')
        return
      }
      this.init()
      this.addWishRes = res
    },
    async cancelCollect(data) {
      console.log('取消关注按钮2')
      const res = await this.$axios.post(oneApi.queryCancelWish, data, { rewritePostBody: true, uid: data.studentId });
      this.isWishEnd = true
      if (Number(res.code) !== 0) {
        this.wishToast('Failed to cancel')
        return
      }
      this.init()
    },
    resetPaymentCountDown() {
      clearTimeout(this.timer);
      this.timer = null;
    },
    startPaymentCountDown() {
      if (this.signUpRemainTime <= 0) {
        this.signUpRemainTime = 0;
        this.resetPaymentCountDown();
        return;
      }
      if (this.signUpRemainTime > 0) {
        this.signUpRemainTime -= 1000;
        this.timer = setTimeout(() => { this.startPaymentCountDown() }, 1000) // 每1000毫秒执行一次
      }
    },
    filterName(val, list) {
      for (let i = 0; i < list.length; i += 1) {
        if (Number(val) === Number(list[i].value)) {
          return list[i].name
        }
      }
      return ''
    },
    // 添加滚动事件
    addScrollEvent() {
      window.addEventListener('scroll', this.watchScroll, false)
    },

    // 移除滚动事件
    removeScrollEvent() {
      if (this.headerRef) { this.headerRef.style.opacity = '1' }
      if (this.headerRef) { this.headerRef.style.zIndex = 999 }
      window.removeEventListener('scroll', this.watchScroll, false)
    },
    changeActiveTab(scrollTop) {
      const teachersOffsetY = document.getElementById('courseTeachers') && document.getElementById('courseTeachers').offsetTop
      const syllabusOffsetTop = document.getElementById('courseSyllabus').offsetTop
      const syllabusOffsetY = syllabusOffsetTop + document.getElementById('courseSyllabus').offsetHeight
      const detailsOffsetY = (document.getElementById('courseDetails') && document.getElementById('courseDetails').offsetTop) || 0
      if (scrollTop >= teachersOffsetY && scrollTop < syllabusOffsetTop) {
        this.activeIndex = 0;
      } else if (scrollTop >= teachersOffsetY && scrollTop < syllabusOffsetY) {
        this.activeIndex = 1;
      } else if (detailsOffsetY && scrollTop >= detailsOffsetY) {
        this.activeIndex = 2;
      }
    },
    // 监听滚动条事件
    watchScroll: throttle(
      function watchScrollTop() {
        // 获取浏览器滚动条高度
        const { scrollTop } = document.documentElement
        // 获取高度
        this.headerRef = document.getElementById('topHeader')
        const priceAndStatus = document.getElementById('priceAndStatus')
        const priceStatus = document.querySelector('.price-status')
        const detailTabOffsetTop = document.getElementById('courseTeachers') && document.getElementById('courseTeachers').offsetTop
        if (scrollTop < detailTabOffsetTop) {
          // 显示头部
          this.headerRef.style.opacity = '1'
          this.headerRef.style.zIndex = 999
          if (priceAndStatus) {
            priceAndStatus.style.display = 'none'
          }
        } else {
          // 隐藏头部
          this.headerRef.style.opacity = '0'
          this.headerRef.style.zIndex = 77
          if (priceAndStatus) {
            priceAndStatus.style.display = 'flex'
            priceStatus.style.left = `${this.$refs.classInfo.offsetWidth - priceStatus.offsetWidth - 20}px`
          }
        }
        setTimeout(() => {
          this.changeActiveTab(scrollTop)
        })
      },
      300,
      { leading: true, trailing: true },
    ),

    // 获取课程类型名字
    getCoursesTypeName(id) {
      return this.filterName(id, this.coursesTypeList)
    },
    // 根据用户诊断成绩校验用户报名资格
    async checkStuEvaluation() {
      const orderSkuId = this.$store.state.order.skuId
      const data = { skuId: orderSkuId || this.courseId }
      const res = await this.$axios.post(oneApi.querySignUpCheckv2, data, { rewritePostBody: true, uid: this.studentId })
      if (res.code !== 0) {
        this.$ElMessage.error(res.msg)
        return false
      }

      const resData = res.data || {}
      if (resData.continue) return true

      // 判断是新诊断逻辑还是旧诊断逻辑
      if (resData.helper && resData.helper.old) {
        this.setEvaluationDialogOld(resData)
      } else {
        const helper = resData.helper || {}
        this.setSignUpCheckInfoDialog(helper)
      }

      // continue 为false，需要根据helper做进一步处理

      return false
    },
    // 请求课程详情页面
    async queryCourseDetail() {
      this.queryDetailStatus = 0
      const data = {
        skuId: this.$route.params.coursesId,
      }
      // 待缴费来源 需要携带首次课时间
      if (this.fromPage === 'unpaid-courses-list' && this.firstLessonNum) {
        data.firstLessonNum = Number(atob(this.firstLessonNum));
      }

      const res = await this.$axios.post(oneApi.queryCourseDetail, data, { rewritePostBody: true });
      if (Number(res.code) === 9) {
        // 登录态过期重新请求
        this.queryCourseDetail();
        return;
      }
      if (Number(res.code) !== 0) {
        // 请求异常
        this.queryDetailStatus = 2
        return
      }
      const resData = res.data || {}
      if (this.$store.state.website.page.isDefault !== 0) {
        // 动态生成标题和描述
        const title = `${resData.title}-${resData.id}`;
        const keywords = `${resData.spec.subjectFullName}, ${resData.spec.courseTypeName}, ${resData.spec.gradeName}, ${resData.spec.levelDegreeName}`;
        const description = `${resData.title}, ${resData.spec.subjectFullName},${resData.spec.courseTypeName}`;
        const seoParams = {
          title,
          description,
          keywords,
          isDefault: '',
        };
        this.$store.dispatch('website/updatePageData', seoParams);
      }
      this.detailData = resData || {};
      this.courseType = resData.spec.courseType
      this.isWish = this.detailData.inWish
      let { remainSellTime } = resData
      // 香港分校倒计时增加5秒随机，防止大量用户同时购买
      if (this.locale === 'hk' && remainSellTime > 1000) {
        const randomMillisecond = window.localStorage.getItem('_official_random_millisecond')
        if (randomMillisecond) {
          remainSellTime += Number(randomMillisecond)
        }
      }
      this.signUpRemainTime = remainSellTime
      this.courseSchedule = JSON.parse(JSON.stringify(this.detailData.spec.courseInfo.syllabus).replace(/name/g, 'lecture_name').replace(/timeDesc/g, 'lecture_time'))
      // 诊断相关信息
      const examEntrance = resData.examEntrance || {}
      this.evaluation.entranceStatus = examEntrance.status || ''
      this.evaluation.examId = examEntrance.examId || ''
      // 设置活动数据
      this.activityInfo = Object.assign(this.activityInfo, resData.activityInfo)
      // 请求成功
      this.queryDetailStatus = 1

      if (this.$store.state.ucenter.isLogin && this.btnStatus.includes('enrol')) {
        if (this.detailData.existStage) await this.getGenerate(this.detailData)
        this.queryCoupons(this.detailData)
        this.getConStudentList(this.detailData)
      }

      if (this.signUpRemainTime > 1000) {
        this.startPaymentCountDown();
      }

      this.courseDetailPv()
    },
    /** 加购 */
    async addCart(params) {
      console.log('addCart params:', params);
      try {
        const { code, msg, data } = await this.$axios.post(oneApi.addCart, params, {
          rewritePostBody: true,
        });
        this.$store.dispatch('cart/getCartCount', { $axios: this.$axios, studentId: params.studentId })
        if (code === 0) {
          const { status, statusDesc } = data
          if (status === 0) {
            this.$ElMessage.success(this.$t('order.shoppingCart.addedSuccess'));
            this.$refs.evaluationRedeemDialog.closeDialog()
          } else if (status === 1 || status === 2) {
            this.setSignUpCheckInfoDialog(data)
          } else {
            this.$ElMessage.error(statusDesc || 'system error');
          }
        } else {
          this.$ElMessage.error(msg || 'system error');
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 报名
     */
    async registrationHandler(orderInfo) {
      this.isAddCart = orderInfo?.type === 'addCart'
      this.isBuying = true
      const skuId = orderInfo.skuId ? orderInfo.skuId : this.courseId
      const orderCreateData = { ...orderInfo }
      orderCreateData.skuId = skuId
      if (orderInfo.way === 'ACTIVITY_GROUP_NEW') {
        orderCreateData.activityId = this.activityInfo.activityId
        orderCreateData.activityType = this.activityInfo.activityType
      }
      // 更新下单途径
      this.$store.dispatch('order/updateCreateOrderInfo', orderCreateData);
      // 更新参与商城活动类型
      this.$store.dispatch('attribution/updateEvent', {
        orderCreateWay: this.$store.state.order.orderCreateWay,
        activityType: this.activityInfo.activityType || this.$store.state.attribution.eventType,
        activityId: this.activityInfo.activityId || this.$store.state.attribution.eventId,
      })

      await this.registrationCheckUser(orderInfo.way === 'ACTIVITY_GROUP_NEW' || orderInfo.way === 'ACTIVITY_GROUP_JOIN');

      this.courseEnrollClick()
    },
    async registrationCheckUser(isGroup = false) {
      this.isBuying = true
      // 判断是否登录状态
      const { isLogin } = this.$store.state.ucenter;
      if (!isLogin) {
        bus.$emit('login', { triggerSrc: 'REGISTRATION_COURSE', triggerSource: 'courses-detail-registration', isGroup });
        this.isBuying = false
        return
      }

      // 子账号优化：
      // 家庭中无子账号+首次下单 => 去掉选择子账号流程
      // 判断是否有子账号
      const resPromise = this.$axios.post(oneApi.getFamilyStudentsList, {}, { rewritePostBody: true });
      const infoPromise = this.$axios.post(oneApi.queryUserBasicInfo, { fillInAttention: true }, { rewritePostBody: true, uid: this.studentId })
      const res = await resPromise
      const info = await infoPromise
      if (Number(res.code) !== 0) {
        this.isLoading = false;
        this.$ElMessage({
          type: 'error',
          message: res.msg,
        });
        return
      }
      const resData = res.data || {};
      this.studentsList = [resData.currentAccount, ...(resData.associatedAccount || [])];
      const hasAccount = resData.associatedAccount && resData.associatedAccount.length > 0
      // 1、若家庭组中无子账号
      // 若为第一次下单，则去掉选择子账号流程
      // tagId === 1，首次下单
      // 若账号下已经有订单（下过单即可，取消的也算），则正常弹窗引导用户选择子账号
      // 2、若家庭组中有子账号
      // 同当前线上，弹窗引导用户选择子账号
      console.log('有子账号 - ', hasAccount)
      console.log('是否是首次下单', info)
      console.log(this.fromPage)
      this.studentInfo = {
        uid: info.data.id,
        nickName: info.data.nickName || '',
        firstName: info.data.firstName || '',
        lastName: info.data.lastName || '',
        email: info.data.email || '',
        phone: info.data.phone || '',
      }
      if (this.studentId) {
        // 判断是否为加购
        if (this.isAddCart) {
          const params = {
            studentId: this.studentId,
            skuId: this.$store.state.order.skuId,
          }
          this.addCart(params)
        } else {
          this.registrationCourse()
        }
      } else if (!hasAccount && [1, '1'].includes(info.data.tagId)) {
        console.log('绕过学生弹窗，直接走报名校验')
        // 判断是否为加购
        if (this.isAddCart) {
          const params = {
            studentId: this.studentId,
            skuId: this.$store.state.order.skuId,
          }
          this.addCart(params)
        } else {
          this.registrationCourse()
        }
      } else {
        console.log('选择学生弹窗')
        if (this.isAddCart) {
          // 选择学员
          this.openSwitchStudentDialog()
        } else {
          this.registrationCourse()
        }
      }
    },
    /**
     * 报名校验
     */
    async registrationCourse() {
      console.log('开始校验')
      this.isBuying = true
      if (!this.$store.state.ucenter.isLogin) {
        bus.$emit('login', { triggerSrc: 'REGISTRATION_COURSE' });
        return
      }
      // 需要校验用户基础信息
      const status = await this.checkStuBase()
      // 诊断校验未通过，无法报名
      if (!status) {
        this.isBuying = false;
        return
      }
      // 去生成订单
      this.createOrder()
    },
    async checkStuBase() {
      const orderSkuId = this.$store.state.order.skuId
      const data = { skuId: orderSkuId || this.courseId }
      const res = await this.$axios.post(oneApi.querySignUpCheckBase, data, { rewritePostBody: true, uid: this.studentId })
      if (res.code !== 0) {
        this.$ElMessage.error(res.msg)
        return false
      }

      const resData = res.data || {}
      if (resData.continue) return true

      const helper = resData.helper || {}
      this.setSignUpCheckInfoDialog(helper)

      return false
    },
    async createOrder() {
      if (!await this.activityRegistrationCheck()) { this.isBuying = false; return }
      const path = this.$store.state.order.createOrderPath
      const query = Object.assign(this.$route.query, this.$store.state.order.createOrderQuery)
      if (!path) { this.isBuying = false; return }
      this.$router.push({
        path,
        query,
      });
      this.isBuying = false;
    },
    moreCourses() {
      const coursesPath = '/courses/list';
      this.$router.push(coursesPath);
    },
    openSwitchStudentDialog() {
      this.$refs.coursesDetailSwitchStudentDialog.openDialog();
    },
    // 设置确认弹窗
    setConfirmDialog(...args) {
      this.confirmDialogConfig = Object.assign(this.confirmDialogConfig, args[0])
    },
    // 诊断入口点击事件
    handleEvaluationEntranceClick() {
      const status = this.evaluation.entranceStatus
      this.evaluationEntranceClick(status)
      switch (status) {
        case 1:
        case 2: {
          // 展示诊断入口，不需要校验
          const { examId } = this.evaluation
          if (!examId) {
            this.$ElMessage.error('no examId')
            return
          }
          const queryObj = {
            courseId: this.detailData.spec.courseId || '',
            skuId: this.courseId,
          }
          evaluation.toEvaluation(this.$store, `/evaluation/instruction/${examId}`, queryObj, 'class_details_page')
          break;
        }
        default:
          break
      }
    },
    // 切换学员成功处理
    switchSuccessHandler(isSwitch, studentInfo) {
      this.isNeedRefresh = isSwitch
      this.studentInfo = studentInfo
      // 判断是否为加购
      if (this.isAddCart) {
        const params = {
          studentId: studentInfo.uid,
          skuId: this.$store.state.order.skuId,
        }
        this.addCart(params)
      } else {
        this.registrationCourse()
      }
    },
    // 报名资格校验结果
    setSignUpCheckInfoDialog(helper) {
      const status = helper.status || helper.status === 0 ? helper.status : ''
      this.signUpStatus = status
      switch (status) {
        case 1: {
          // 需要入学测，剩余作答机会>0
          const leftChance = helper.extra && helper.extra.leftChance ? helper.extra.leftChance : 0
          const examId = helper.extra && helper.extra.examId ? helper.extra.examId : ''
          const queryObj = {
            courseId: this.detailData.spec.courseId || '',
            skuId: this.courseId,
          }
          const isTmc = this.$store.state.locale === 'tmc'
          this.setConfirmDialog({
            show: true,
            title: this.$t('coursesDetail.signUpCheckInfoDialog.case1.title'),
            content: this.$t('coursesDetail.signUpCheckInfoDialog.case1.content', [leftChance, leftChance > 1 ? 's' : '', isTmc ? `您的孩子需要通过入学诊断，然后才能报名参加这个课程，只有${leftChance}次机会` : '']),
            mainBtnText: this.$t('coursesDetail.signUpCheckInfoDialog.case1.mainBtnText'),
            mainBtnClick: () => {
              // 美分&非数学学科
              const subjuetFullName = this.detailData.spec.subjectFullName.toLocaleLowerCase() || ''
              if (this.$store.state.locale === 'us' && !subjuetFullName.includes('math')) {
                this.$router.push('/1-to-1-assessment');
                return
              }
              if (!examId) {
                this.$ElMessage.error('no examId')
                if (this.isNeedRefresh) this.init()
                return
              }
              evaluation.toEvaluation(this.$store, `/evaluation/instruction/${examId}`, queryObj, 'class_register_pop_up')
              this.startTestClick(examId)
              if (this.isNeedRefresh) this.init()
            },
            subBtnText: this.$t('coursesDetail.signUpCheckInfoDialog.case604.subBtnText'),
            subBtnClick: () => {
              this.confirmDialogConfig.show = false
              if (this.isNeedRefresh) this.init()
            },
          })
          break;
        }
        case 2: {
          // 无法报名-诊断校验未通过
          this.setConfirmDialog({
            show: true,
            title: this.$t('coursesDetail.signUpCheckInfoDialog.case2.unableSignUp'),
            content: helper.statusDesc || this.$t('coursesDetail.signUpCheckInfoDialog.case2.msg'),
            mainBtnText: this.$t('coursesDetail.signUpCheckInfoDialog.case2.ok'),
            mainBtnClick: () => {
              // 美分&非数学学科
              const subjuetFullName = this.detailData.spec.subjectFullName.toLocaleLowerCase() || ''
              if (this.$store.state.locale === 'us' && !subjuetFullName.includes('math')) {
                this.$router.push('/1-to-1-assessment');
                return
              }
              this.confirmDialogConfig.show = false
              if (this.isNeedRefresh) this.init()
            },
          })
          break
        }
        case 3: {
          // 无法报名-不符合报班资格(不符合班课策略要求)
          const msg = helper.statusDesc || ''
          this.setConfirmDialog({
            show: true,
            title: this.$t('coursesDetail.signUpCheckInfoDialog.case3.title'),
            content: msg,
            mainBtnText: this.$t('coursesDetail.signUpCheckInfoDialog.case3.mainBtnText'),
            mainBtnClick: () => {
              this.confirmDialogConfig.show = false
              if (this.isNeedRefresh) this.init()
            },
            subBtnText: '',
            subBtnClick: () => {},
          })
          break;
        }
        case 4: {
          this.checkEmailOrPhone('email', true, this.newEmailOrPhone)
          break;
        }
        case 5: {
          this.checkEmailOrPhone('phone', true, this.newEmailOrPhone)
          break;
        }
        case 6: {
          // 需要完善个人信息
          bus.$emit('complete-stu-info', { triggerSrc: 'REGISTRATION_COURSE', studentInfo: this.studentInfo || this.studentsList[0] });
          this.isBuying = false;
          break;
        }
        case 1014: {
          // 存在自动扣款中的分期
          this.setConfirmDialog({
            show: true,
            title: this.$t('coursesDetail.signUpCheckInfoDialog.case1014.title'),
            content: this.$t('coursesDetail.signUpCheckInfoDialog.case1014.content'),
            mainBtnText: this.$t('coursesDetail.signUpCheckInfoDialog.case1014.mainBtnText'),
            mainBtnClick: () => {
              this.confirmDialogConfig.show = false
              this.init()
            },
            subBtnText: '',
            subBtnClick: () => {},
          })
          break;
        }
        case 604: {
          // 限时购-简版提示弹窗
          this.setConfirmDialog({
            show: true,
            title: this.$t('coursesDetail.signUpCheckInfoDialog.case604.title'),
            content: this.$t('coursesDetail.signUpCheckInfoDialog.case604.content'),
            mainBtnText: this.$t('coursesDetail.signUpCheckInfoDialog.case604.mainBtnText'),
            mainBtnClick: () => {
              this.confirmDialogConfig.show = false
              this.$router.push('/courses/list')
            },
            subBtnText: this.$t('coursesDetail.signUpCheckInfoDialog.case604.subBtnText'),
            subBtnClick: () => {
              this.confirmDialogConfig.show = false
            },
          })
          break;
        }
        default: {
          const msg = helper.statusDesc || 'system error'
          this.$ElMessage.error(msg)
          if (this.isNeedRefresh) this.init()
          break;
        }
      }
    },
    // 诊断兑换码入口点击事件
    openEvaluationRedeemDialog() {
      // 关闭当前弹窗
      this.setConfirmDialog({ show: false })
      this.$refs.evaluationRedeemDialog.openDialog()
      this.evaluationRedeemDialogShow()
    },
    // 兑换成功后按钮点击事件处理
    redeemMainClickHandler(redeemResult) {
      if (!redeemResult.isRedeem) {
        // 继续报名
        // 判断是否为加购
        if (this.isAddCart) {
          const params = {
            studentId: this.studentId,
            skuId: this.$store.state.order.skuId,
          }
          this.addCart(params)
        } else {
          this.registrationCourse()
        }
      } else {
        const code = redeemResult.redeemCode || ''
        this.$router.push(`/test/recommended-classes/${code}`)
      }
    },
    // 旧诊断处理逻辑
    setEvaluationDialogOld(res) {
      //  需参与诊断测试
      if (Number(res.helper.status) === 1) {
        this.evaluationDialogInfo = {
          title: 'Evaluation Required',
          message: "Think Academy will recommend the best fit class based on the student's evaluation test",
          confirmButtonText: 'Take Evaluation Now',
          showCancel: true,
          res,
        }
        this.showEvaluationDialog = true;
        return
      }
      // 有成绩但是不符合报班条件
      if (Number(res.helper.status) === 2) {
        this.evaluationDialogInfo = {
          title: "Your evaluation score doesn't satisfy this class level",
          message: 'Based on your evaluation, we recommend you for 1 class level',
          confirmButtonText: 'OK',
          showCancel: false,
          res,
        }
        this.showEvaluationDialog = true;
        return
      }
      // 需要不符合班课策略要求 - 已报名
      if (Number(res.helper.status) === 3) {
        this.evaluationDialogInfo = {
          title: 'Reminder',
          message: res.helper.statusDesc,
          confirmButtonText: 'Confirm',
          showCancel: false,
          res,
        }
        this.showEvaluationDialog = true;
      }
      //  账号缺少联系邮箱
      if (Number(res.helper.status) === 4) {
        this.checkEmailOrPhone('email', true, this.newEmailOrPhone)
        return
      }
      //  账号缺少联系手机号
      if (Number(res.helper.status) === 5) {
        this.checkEmailOrPhone('phone', true, this.newEmailOrPhone)
      }
      //  需要完善个人信息
      if (Number(res.helper.status) === 6) {
        bus.$emit('complete-stu-info', { triggerSrc: 'REGISTRATION_COURSE', studentInfo: this.studentInfo || this.studentsList[0] });
        this.isBuying = false;
      }
    },
    exceptionRetryHandler() {
      this.$router.replace('/courses/list')
    },
    // 隐藏优惠券使用提示
    hiddenCouponBubble() {
      this.showCouponBubble = false
    },
    checkEmailOrPhone(type, execute, guide) {
      // 绑定手机号/邮箱优化
      this.$store.dispatch('bindDialog/setDialogData', {
        visible: true,
        type,
        execute: execute || false,
        guide: guide || null,
      })
    },
    async newEmailOrPhone(obj) {
      let data = {}
      let res;
      // let data2 = null

      // if (obj.phone) {
      //   data2 = {
      //     type: 0,
      //     contactInfo: obj.phone,
      //     countryCallingCode: obj.phoneAreaCode.value,
      //   }
      // } else {
      //   data2 = {
      //     type: 2,
      //     contactInfo: obj,
      //   }
      // }
      console.log('校验手机号36');
      // const res2 = await this.$axios.post(oneApi.contactVerify, data2, { rewritePostBody: true })

      // if (Number(res2.code) !== 0) {
      //   this.$ElMessage({
      //     type: 'error',
      //     message: res2.msg,
      //   });
      //   return;
      // }

      if (obj.phone) {
        data = {
          attentionPhone: obj.phone,
          attentionCountryCode: obj.phoneAreaCode.value,
        }
        res = await this.$axios.post(oneApi.bindEmail2, data, { rewritePostBody: true, uid: this.studentId })
      } else {
        data = {
          attentionEmail: obj,
        }
        res = await this.$axios.post(oneApi.bindEmail2, data, { rewritePostBody: true, uid: this.studentId })
      }

      // 触发后续购课流程
      if (Number(res.code) !== 0) {
        this.$ElMessage({
          type: 'error',
          message: res.msg,
        });
        return;
      }
      this.$store.dispatch('ucenter/queryUserBasicInfo', { $axios: this.$axios, userData: { fillInAttention: false } });
      if (this.$route.name === 'my-unpaid-courses-list') {
        bus.$emit('unpaid.list.registrationCourses', { uid: this.studentId })
      }
      this.$store.dispatch('bindDialog/close')
      // 判断是否为加购
      if (this.isAddCart) {
        const params = {
          studentId: this.studentId,
          skuId: this.$store.state.order.skuId,
        }
        this.addCart(params)
      } else {
        this.registrationCourse()
      }
    },
    // 神策埋点 - 班级详情页PV
    courseDetailPv() {
      const fromSourcePage = this.getClassFrom(this.fromSource)
      this.Sensors.track('class_detail_pv', this.getClassSaData(fromSourcePage, this.detailData))
    },
    // 神策埋点 - 班级介绍曝光诊断入口点击
    evaluationEntranceClick(status) {
      const data = this.getClassSaData('', this.detailData)
      data.test_id = this.evaluation.examId
      data.test_type = status || 0
      this.Sensors.track('class_detail_test_click', data)
    },
    // 神策埋点-点击报名
    courseEnrollClick() {
      const fromSourcePage = this.getClassFrom(this.fromSource)
      const data = this.getClassSaData(fromSourcePage, this.detailData)
      data.active_type = this.activityInfo.activityType || null
      this.Sensors.track('enroll_click', data)
    },
    // 神策埋点-开始诊断
    startTestClick(examId) {
      this.Sensors.track('enroll_start_test_click', {
        course_id: this.detailData.spec.courseId,
        class_id: this.detailData.spec.clazzId,
        quiz_id: examId,
      })
    },
    // 神策埋点-诊断兑换码弹窗曝光
    evaluationRedeemDialogShow() {
      this.Sensors.track('qualification_code_pv', {
        course_id: this.detailData.spec.courseId,
        class_id: this.detailData.spec.clazzId,
        previous_source: '班级详情页',
      })
    },
    // 神策埋点-收藏
    collectClickHandler(operationType) {
      const data = this.getClassSaData('', this.detailData)
      data.operation_type = operationType
      this.Sensors.track('class_favorites', data)
    },
    // 设置右侧漂浮层top值
    setCourseInformationTop() {
      this.courseInformationTop = document.getElementById('topHeader').offsetHeight + 54
    },
  },
}
</script>
<style lang="scss" scoped>
.course-detail-wrapper {
  .fee-description {
    text-indent: 17px;
    margin-top: 9px;
    font-size: 10px;
    color: var(--txt-color-lv2);
    line-height: 12px;
  }

  .exception-container,
  .error-container {
    padding: 110px 0;
    min-height: calc(100vh - 430px);
  }

  // 诊断兑换码入口
  .evaluation-redeem-code-entrance {
    margin: 20px auto -24px;
    padding: 8px 16px;
    width: 350px;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    border-radius: 10px;
    color: var(--txt-color-lv2);
    background: rgba(244, 246, 250, 0.5);

    .btn-text {
      color: var(--txt-color-link);
      text-decoration: underline;
      cursor: pointer;

      &:hover {
        color: var(--txt-color-link2);
      }
    }
  }

  .evaluation-entrance-wrapper {
    margin: 24px 0 0;
    width: 780px;
    height: 64px;
    border-radius: 10px;
    background: #fff;

    &.clickable {
      cursor: pointer;
    }

    .evaluation-entrance-container {
      display: flex;
      padding: 8px 16px;

      .evaluation-logo-img {
        margin-right: 8px;
        width: 48px;
        height: 48px;
        background-position: center;
        background-size: cover;
        background-color: #f4f6fa;

        &.success {
          background-image: url('~assets/images/courses/evaluation-entrance-success-icon.jpg');
        }

        &.common {
          background-image: url('~assets/images/courses/evaluation-entrance-icon.jpg');
        }
      }

      .evaluation-detail-info {
        .evaluation-name {
          margin: 5px 0 4px;
          font-size: 16px;
          line-height: 19px;
          color: var(--txt-color-lv1);
        }

        .evaluation-desc {
          font-size: 14px;
          line-height: 16px;
          color: var(--txt-color-lv2);
        }
      }
    }
  }

  // 右侧悬浮卡片样式
  .course-information {
    position: sticky;
    left: 840px;
    top: 104px;
    width: 400px;
    border-radius: 9px;
    padding-bottom: 90px;
    height: fit-content;

    .top-courses-info {
      margin-bottom: 1px;
      background: #fff;
      border-radius: 9px;
      overflow: hidden;

      .class-card-wrapper {
        border: none;
      }
    }

    .coupon-tip-bubble {
      display: none;
      justify-content: space-between;
      align-items: center;
      margin: 0;
      padding: 0;
      width: 400px;
      height: 0;
      font-size: 12px;
      line-height: 14px;
      text-align: left;
      border-radius: 8px;
      color: var(--txt-color-link);
      background: rgba(255, 255, 255, 0.95);
      visibility: hidden;
      opacity: 0;
      transition: all 0.4s cubic-bezier(0.645, 0.045, 0.355, 1);

      &.show {
        display: flex;
        margin: 20px 0 0;
        padding: 10px 16px;
        height: fit-content;
        visibility: visible;
        opacity: 1;
      }

      .btn-close {
        flex-shrink: 0;
        width: 26px;
        height: 26px;
        color: var(--txt-color-lv2);
        text-align: center;
        border-radius: 50%;
        background: #f4f6fa;
        cursor: pointer;

        .iconfont {
          font-weight: bold;
          line-height: 26px;
        }
      }
    }

    .coupon-tip-hk {
      margin-top: -80px;
      padding: 20px 16px 6px;
      width: 100%;
      background: rgba(222, 226, 231, 0.3);
      border-radius: 10px;

      .coupon-tip-title {
        font-size: 14px;
        font-weight: 500;
        color: var(--txt-color-lv1);
        line-height: 20px;
      }

      .coupon-tip-des {
        font-size: 12px;
        font-weight: 500;
        color: var(--txt-color-lv2);
        line-height: 17px;
      }
    }
  }
  // 通用提示文案样式
  .normal-tip-text {
    font-size: 12px;
    line-height: 14px;
    color: var(--txt-color-lv2);
    word-spacing: 0;
    letter-spacing: 0;

    &.auto-pay-in-process-tip {
      margin-top: 8px;
    }
  }
}

.course-detail {
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: #f4f6fa;

  .course-detail-crumb {
    padding: 20px 0;
  }

  .outline-introduce {
    position: relative;
    display: flex;
    min-width: 1240px;

    .class-info {
      width: 780px;
      padding: 0 60px 72px 0;
      background: #f4f6fa;
      box-sizing: content-box;

      .class-main-info-card {
        padding-bottom: 6px;
        border-radius: 10px;
        background: #fff;
        border: none;
      }
    }

    .fee-description {
      font-size: 12px;
      color: var(--txt-color-lv2);
      line-height: 14px;
    }
  }
}
</style>
